import React, { Component } from 'react';
import * as Styles from './Styles';
import Tab from '../../shared/tab/Tab';
import * as Content from './faqContent';
import SvgArrowDown2 from '../../../others/svg_dist/ArrowDown2';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../core/Store';
import * as AppManager from '../../../reducers/ui/app';

type State = {};

class FaqComponent extends Component<PropsFromRedux, State> {
	state = {};

	scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	render() {
		return (
			<Styles.Wrapper>
				{this.props.bodyScrolled && (
					<Styles.TopButton onClick={() => this.scrollToTop()}>
						<SvgArrowDown2 />
					</Styles.TopButton>
				)}
				{Content.Faq.map((el, idx) => (
					<Tab
						key={idx}
						accent="#03a4ec"
						content={el.content}
						heading={el.heading}
						no={idx + 1}
					/>
				))}
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		bodyScrolled: AppManager.Selectors.getIsBodyScrolled(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Faq = connector(FaqComponent);
export default Faq;
